import { useState } from "react";

function TagInput({
  label,
  values,
  onChange,
  placeholder = "Type and press Enter",
  isEditable,
}) {
  const [input, setInput] = useState("");

  const addTag = () => {
    const trimmed = input.trim();
    if (trimmed && !values.includes(trimmed)) {
      onChange([...values, trimmed]);
    }
    setInput("");
  };

  const removeTag = (idx) => {
    const updated = values.filter((_, i) => i !== idx);
    onChange(updated);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      addTag();
    }
  };

  return (
    <div
      className={`col-span-2 sm:flex ${
        !isEditable ? "cursor-not-allowed" : ""
      }`}
    >
      <label className="block mb-1 font-medium min-w-[150px]">{label}</label>
      <div className={`flex flex-wrap items-center gap-2 border rounded px-2 py-2 ${isEditable ? 'bg-gray-100' : ''}`}>
        {values.map((tag, idx) => (
          <span
            key={idx}
            className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-1 rounded-full flex items-center gap-1"
          >
            {tag}
            <button
              onClick={() => removeTag(idx)}
              className={`text-blue-500 hover:text-red-500 ${
                isEditable ? "hidden" : ""
              }`}
            >
              &times;
            </button>
          </span>
        ))}
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          disabled={isEditable}
          className="flex-1 bg-transparent outline-none text-sm py-1"
        />
      </div>
    </div>
  );
}

export default TagInput;
